import React from 'react'

export default function Mode({onModeChange}) {
  return (
    <div className='hide-mobile'>
      <div className="mt-4">
        
        <input
            class='mr-2 rounded-[0.4375rem]'
            type="checkbox"
            role="switch"
            onChange={onModeChange}
            id="flexSwitchCheckDefault" />
            <label
                class="inline-block pl-[0.15rem] hover:cursor-pointer"
                for="flexSwitchCheckDefault"
            />
            Two Fingers
      </div>
    </div>
  )
}
